import {YA_KZ_ID, YA_RU_ID} from "js/constant/common";

export function reachGoal(name) {
    try {
        if (window.country_code === 'ru') {
            ym(YA_RU_ID, "reachGoal", name)
        } else if (window.country_code === 'kz') {
            ym(YA_KZ_ID, "reachGoal", name + '_kz')
        }
    } catch (e) {
        // ignore
    }
}
